export interface GraphqlExtensionPersistedQuery {
  version: number;
  sha256Hash: string;
}

const sha256Hash = async (query: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(query);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
};

export const buildPersistedQueryExtension = async (
  query: string
): Promise<GraphqlExtensionPersistedQuery> => {
  return { version: 1, sha256Hash: await sha256Hash(query) };
};
